export const navLinks = [
  { label: '分区索引', href: '#shelf' },
  { label: '干货合集', href: '#collections' },
  { label: '常翻热榜', href: '#hot' },
  { label: '新入库', href: '#newin' },
  { label: '找料指引', href: '#guide' },
];

export const heroCards = [
  {
    code: '甲',
    title: '私藏存货',
    desc: '按主题归整好的核心存货，想翻哪类直接进，不绕路。',
    count: '128 档',
    tone: 'gold',
  },
  {
    code: '乙',
    title: '干货家底',
    desc: '压箱底的深度合集与盘点，一次看够的那种。',
    count: '96 档',
    tone: 'paper',
  },
  {
    code: '丙',
    title: '热门爆料',
    desc: '近期热议事件的来龙去脉与反转，节奏快、更新勤。',
    count: '每日新增',
    tone: 'gold',
  },
  {
    code: '丁',
    title: '往期宝库',
    desc: '被时间淹没的老料重新归档，冷门也能挖得动。',
    count: '300+ 档',
    tone: 'paper',
  },
];

export const heroStats = [
  { label: '已归档档目', value: '8600+' },
  { label: '累计整理时长', value: '4.2 年' },
  { label: '常驻分类主题', value: '48 类' },
  { label: '每周稳定更新', value: '15 档' },
];

export interface ShelfCard {
  code: string;
  name: string;
  desc: string;
  tags: string[];
  count: string;
  featured?: boolean;
}

export const shelfSections: ShelfCard[] = [
  {
    code: '壹',
    name: '吃瓜现场',
    desc: '把热乎事件的来龙去脉、最新进展与反转一条条摊开，谁先谁后、谁说的都能顺着时间线看明白，不迷路。',
    tags: ['最新进展', '反转', '围观指南'],
    count: '1,240 档',
    featured: true,
  },
  {
    code: '贰',
    name: '专题深挖',
    desc: '围绕同一主题长期跟进的整理，事件被拆成可检索的时间线，适合一次看懂一个完整脉络。',
    tags: ['时间线', '跟踪', '复盘'],
    count: '880 档',
    featured: true,
  },
  {
    code: '叁',
    name: '争议复盘',
    desc: '风口浪尖过去之后，把各方说法与关键节点重新梳理成册，理性回看的那类存货。',
    tags: ['复盘', '关键节点', '视角'],
    count: '560 档',
  },
  {
    code: '肆',
    name: '幕后花絮',
    desc: '镜头之外的小细节、边角料与周边，攒起来也是很有意思的一类家底。',
    tags: ['花絮', '周边', '细枝末节'],
    count: '430 档',
  },
  {
    code: '伍',
    name: '冷门库存',
    desc: '被时间冲淡的往期旧料重新翻出来，整理好随时可挖，越冷越有味道。',
    tags: ['老料', '旧档重提', '怀旧'],
    count: '690 档',
  },
  {
    code: '陆',
    name: '年册盘点',
    desc: '按年份归档的年度总览与各类榜单，一年看下来哪些最值得回翻一目了然。',
    tags: ['年度', '榜单', '汇总'],
    count: '320 档',
  },
  {
    code: '柒',
    name: '观点存档',
    desc: '各方声音与讨论切片按主题存放，方便对照，避免只看一个角度。',
    tags: ['讨论', '对照', '存档'],
    count: '770 档',
  },
  {
    code: '捌',
    name: '工具与检索',
    desc: '让找料更省心的检索技巧与整理工具，属于帮你少走弯路的干货家底。',
    tags: ['检索', '指引', '工具'],
    count: '180 档',
  },
];

export const collectionFeature = {
  tag: '年度推荐合集',
  title: '2025 · 全站高翻合集',
  desc: '把全年回翻次数最高的一批存货攒成一本，从开年到年末的大事小情都码得整整齐齐，适合当成快速入口。',
  meta: '覆盖 12 个专题 · 共 214 档 · 持续补录',
};

export const collectionList = [
  {
    no: '01',
    title: '年末大盘点',
    desc: '把一年里反复被翻的热门条目集中成册，翻起来不费劲。',
  },
  {
    no: '02',
    title: '长线事件簿',
    desc: '多期连载合集，跟着时间线一路看完整个故事。',
  },
  {
    no: '03',
    title: '一句话看懂',
    desc: '快速上手的轻量档，适合时间不多只想扫一眼核心的人。',
  },
  {
    no: '04',
    title: '旧档重开箱',
    desc: '往年压箱底的老料重新分类上架，越挖越有意思。',
  },
];

export interface HotItem {
  rank: number;
  title: string;
  tag: string;
  desc: string;
  heat: string;
  update: string;
}

export const hotRank: HotItem[] = [
  {
    rank: 1,
    title: '本周热议事件梳理',
    tag: '吃瓜现场',
    desc: '近几天讨论度最高的线索整合成一页，起点到现状都有。',
    heat: '98.6万',
    update: '刚刚整理',
  },
  {
    rank: 2,
    title: '焦点专题合集 · 一册看懂',
    tag: '专题深挖',
    desc: '跨度最长的连载合集之一，老料新料接得严丝合缝。',
    heat: '82.1万',
    update: '3 小时前',
  },
  {
    rank: 3,
    title: '旧档重提：被翻出来的老料',
    tag: '冷门库存',
    desc: '沉寂多时的往期存货最近又被翻热，重新标好可直挖。',
    heat: '67.4万',
    update: '昨日',
  },
  {
    rank: 4,
    title: '来龙去脉速览档',
    tag: '争议复盘',
    desc: '把来龙去脉摊平了讲，新人也能几分钟看明白前因后果。',
    heat: '55.8万',
    update: '2 天前',
  },
  {
    rank: 5,
    title: '年末盘点抢先看',
    tag: '年册盘点',
    desc: '年度榜单提前开箱，把全年最值得回翻的目录摆上台面。',
    heat: '41.2万',
    update: '4 天前',
  },
];

export interface NewItem {
  date: string;
  month: string;
  type: string;
  title: string;
  desc: string;
  isNew?: boolean;
}

export const newArrivals: NewItem[] = [
  {
    date: '09-05',
    month: '九月',
    type: '专题深挖',
    title: '「长线事件簿」补录新章',
    desc: '把近一周的来龙去脉续进既有合集，老档接新料。',
    isNew: true,
  },
  {
    date: '09-04',
    month: '九月',
    type: '热门爆料',
    title: '热议事件速览档上新',
    desc: '最新进展已整理，反转节点按顺序排好。',
    isNew: true,
  },
  {
    date: '09-03',
    month: '九月',
    type: '冷门库存',
    title: '旧档重新归档上架',
    desc: '一批沉寂老料重新分类，标签补齐后可直接翻。',
  },
  {
    date: '09-01',
    month: '九月',
    type: '年册盘点',
    title: '月度回翻榜开箱',
    desc: '八月的热门存货按回翻次数排了个名。',
  },
  {
    date: '08-28',
    month: '八月',
    type: '观点存档',
    title: '讨论切片收录一批',
    desc: '各方声音归档对照，方便从不同角度看同一件事。',
  },
];

export const guideSteps = [
  {
    no: '一',
    icon: 'ri-folder-3-line',
    title: '先挑分区',
    desc: '从首屏或分区索引选你感兴趣的类型，先锁定大方向。',
  },
  {
    no: '二',
    icon: 'ri-price-tag-3-line',
    title: '用标签收窄',
    desc: '每个档目都配了主题标签，按标签点几次就能筛到想要的。',
  },
  {
    no: '三',
    icon: 'ri-archive-drawer-line',
    title: '打开翻详情',
    desc: '进入条目后按时间线看整理，来龙去脉一次讲清楚。',
  },
  {
    no: '四',
    icon: 'ri-bookmark-line',
    title: '收藏好回翻',
    desc: '把常看的合集收进自己的常翻位，下次进来直接挖。',
  },
];

export const aboutChips = [
  '以整理为先，不追现场噪音',
  '新旧存货持续补录归档',
  '条目均按主题与时间线归类',
  '分类、标签与索引持续优化',
];